<span class="like-count">{{ count }}</span>
<app-icon
  src="assets/images/like.svg"
  class="like"
  [class.liked]="liked"
  (click)="likedChange.emit(!liked)"
></app-icon>
